<template>
  <div>
    <span>{{ getOrderDate() }}</span>
  </div>
</template>

<script>
import get from "lodash/get";
import { formatDate } from "../../../../../../helpers/common";

export default {
  name: "OrdersTableName",

  data() {
    return {
      data: {},
    };
  },

  computed: {
    lang: function () {
      return this.$i18n.locale;
    },
  },

  methods: {
    getOrderDate() {
      const orderDate = get(this.data, "order.order.ts_created");
      const dateString = formatDate(orderDate, "d.M.Y - HH:mm");
      return orderDate ? dateString : "";
    },
  },
};
</script>
